import type { MantineColor, MantineColorShade } from "@mantine/core";
import type { ChatTask } from "@/sdk/agent/chat";

export type ChatVariant =
    | "default"
    | "incoming"
    | "inactive"
    | "neglected"
    | "closedByCustomer"
    | "closedByExpert"
    | "transferredNeglected";

export const getChatVariant = ({
    status,
    isCustomerAbsent,
    isNeglected,
    isClosedByCustomer,
    wasTaskNeglected,
}: ChatTask): ChatVariant => {
    switch (status) {
        case "pending":
            return "incoming";
        case "wrapping":
            return isClosedByCustomer ? "closedByCustomer" : "closedByExpert";
        case "assigned":
        default: {
            if (isNeglected) return "neglected";
            if (isCustomerAbsent) return "inactive";
            if (wasTaskNeglected) return "transferredNeglected";
            return "default";
        }
    }
};

export const getColorByVariant = (
    variant: ChatVariant,
): `var(--mantine-color-${MantineColor}-${MantineColorShade})` => {
    switch (variant) {
        case "neglected":
            return "var(--mantine-color-error-6)";
        case "inactive":
            return "var(--mantine-color-dark-2)";
        case "closedByCustomer":
        case "closedByExpert":
            return "var(--mantine-color-primary-2)";
        case "incoming":
        case "default":
        default:
            return "var(--mantine-color-dark-4)";
    }
};

export interface ChatVariantProps {
    variant: ChatVariant;
    variantColor: MantineColor;
}
